import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Layout components
import Header from './MyCompnents/Header';
import Footer from './MyCompnents/Footer';
import ScrollToTop from './MyCompnents/ScrollToTop';

// Pages
import Home from './pages/home/home';
import About from './pages/about/about';
import ServicesPage from './pages/services/services';
import Team from './pages/team/team';
import Testimonials from './pages/testimonials/testimonials';
import Contact from './pages/contact/contact';
import PrivacyPolicy from './pages/privacy/PrivacyPolicy';

// Service Detail Pages
import AppDevelopment from './pages/services/ITservices/AppDevelopment/AppDevelopment';
import SocialMediaMarketing from './pages/services/ITservices/SocialMediaMarketing/SocialMediaMarketing';
import WebDevelopment from './pages/services/ITservices/WebDevelopment/webdevelopment'; // I'll check if these work or need wrapping
import RecruitmentServices from './pages/services/Recuriment.Sevices/Hr.services/recruitment-services';
import EntryMiddleRecruitment from './pages/services/Recuriment.Sevices/MiddleEntryLevelHiring/entry-middle-recruitment';
import PayrollServices from './pages/services/Recuriment.Sevices/ThirdPartyPayroll/payroll-services';
import CEOMessage from './pages/about/ceomessage/ceomessage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/team" element={<Team />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/services/app-development" element={<AppDevelopment />} />
            <Route path="/services/social-media-marketing" element={<SocialMediaMarketing />} />
            <Route path="/services/web-development" element={<WebDevelopment />} />
            <Route path="/services/recruitment-services" element={<RecruitmentServices />} />
            <Route path="/services/entry-middle-level-hiring" element={<EntryMiddleRecruitment />} />
            <Route path="/services/payroll-services" element={<PayrollServices />} />
            <Route path="/about/ceo-message" element={<CEOMessage />} />

            {/* Redirects for legacy indexed routes (Google Search) */}
            <Route path="/about-us" element={<Navigate to="/about" replace />} />
            <Route path="/about-us/" element={<Navigate to="/about" replace />} />
            <Route path="/contact-us" element={<Navigate to="/contact" replace />} />
            <Route path="/contact-us/" element={<Navigate to="/contact" replace />} />
            <Route path="/career" element={<Navigate to="/services" replace />} />
            <Route path="/career/" element={<Navigate to="/services" replace />} />
            <Route path="/blogs" element={<Navigate to="/" replace />} />
            <Route path="/blogs/" element={<Navigate to="/" replace />} />
            <Route path="/industry-practices" element={<Navigate to="/services" replace />} />
            <Route path="/industry-practices/" element={<Navigate to="/services" replace />} />
            <Route path="/ceo-message" element={<Navigate to="/about/ceo-message" replace />} />
            <Route path="/ceo-message/" element={<Navigate to="/about/ceo-message" replace />} />

            {/* Catch-all fallback redirecting to Home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;